/* Al Sultan Omar — product page extras on top of Saduq Care theme.js
   - size switch: variant title line, WhatsApp order link (size + price), hide "خليها كيلو" when the kilo is picked
   - Judge.me: Arabic labels until the app language is switched in its settings */
(() => {
  'use strict';
  if (window.__spReady) return;
  window.__spReady = true;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money0 = (c) => (window.formatMoney0 ? window.formatMoney0(c) : Math.round(c / 100));

  document.addEventListener('variant:change', (e) => {
    const v = e.detail && e.detail.variant;
    if (!v) return;
    $$('[data-sl-vtitle]').forEach((el) => (el.textContent = v.title));
    $$('[data-sl-wa]').forEach((a) => {
      try {
        const u = new URL(a.href);
        // sl-wa-url adds the "[من الموقع] " prefix server-side; keep it here too
        u.searchParams.set('text', `[من الموقع] ${a.dataset.t} ${v.title} (${money0(v.price)})`);
        a.href = u.toString();
      } catch (_) {}
    });
    $$('[data-sl-upk]').forEach((el) => (el.hidden = el.dataset.slUpk === String(v.id)));
  });

  /* Judge.me widget copy (same mapping as the live theme) */
  const T = {
    'Customer Reviews': '',
    'Be the first to write a review': 'لسه مفيش تقييمات.. كن أول واحد يقول رأيه',
    'Write a review': 'اكتب رأيك',
    'Cancel review': 'إلغاء'
  };
  function arabize() {
    const r = document.getElementById('product-reviews');
    if (!r) return;
    r.querySelectorAll('*').forEach((el) => {
      if (el.children.length) return;
      const t = (el.textContent || '').trim();
      if (t in T) {
        if (T[t] === '') el.style.display = 'none';
        else el.textContent = T[t];
      }
    });
  }
  let n = 0;
  const iv = setInterval(() => { arabize(); if (++n > 20) clearInterval(iv); }, 500);
})();
